import { oneDaysMilli } from '../../constants-types';
import { ModuleName, TimeTrial } from '../../core-data-model';
import { ModuleAccessService } from './ModuleAccess.service';

const getMock: () => Partial<ModuleAccessService> = () => ({
    isPaidAccount(moduleName: string): boolean {
        return false;
    },
    isTimeTrialExpired(module: ModuleName): boolean {
        return false;
    },
    isTimeTrialEnabled: (_moduleName: ModuleName): boolean => false,
    getTimeTrialDetails: (_moduleName: ModuleName): TimeTrial =>
        ({
            startDate: new Date(Date.now()),
            endDate: new Date(Date.now() + oneDaysMilli * 7)
        }) as unknown as TimeTrial
});

export const moduleAccessServiceMock = {
    getMock,
    provider: (Service: typeof ModuleAccessService) => ({
        provide: Service,
        useValue: getMock()
    })
};
